import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableFooter, TableHeader } from "../utils/Table";
import Pagination from "../utils/Pagination";
import {
  calculateTotal,
  decodeData,
  errorToaster,
  formatDate,
  successToaster,
} from "../utils/Helper";
import { useNavigate } from "react-router-dom";
import { getMethod } from "../service";
import { WINNERS_API } from "../service/constant";
import moment from "moment";
import DateRangeFormat from "../utils/DateRangeFormat";
import SubmitBtn from "../utils/SubmitBtn";
import Input from "../utils/Input";

const Winners = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [page, setPage] = useState(1);
  const [refs, setRefs] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [winners, setWinners] = useState([]);
  const [searchId, setSearchId] = useState("");

  const navigate = useNavigate();

  const fetchWinnersAndStats = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const winnersRes = await getMethod(
          `${WINNERS_API}?page=${page}&limit=50&start_date=${startDate}&end_date=${endDate}&search=${searchId}`,
          token.token
        );
        setIsLoading(false);
        if (winnersRes?.isSuccess) {
          setWinners(winnersRes?.data);
          setFrom((winnersRes.meta?.current_page - 1) * 50);
          setTotalPage(winnersRes.meta?.last_page);
        } else {
          errorToaster("Failed to fetch winners");
        }
      } catch (error) {
        errorToaster("An error occurred");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  useEffect(() => {
    fetchWinnersAndStats();
  }, [refs, page]);

  return (
    <Template title={"Winners"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={searchId}
              event={(e) => setSearchId(e.target.value)}
              placeholder="Search User Name OR Phone"
            />
          </div>

          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Number</th>
              <th>Bet Amount</th>
              <th>Odds</th>
              <th>Payout</th>
              <th>Status</th>
              <th>Created At</th>
              <th>Updated At</th>
            </TableHeader>
            <TableBody>
              {winners.length > 0 &&
                winners.map((winner, i) => (
                  <tr key={winner._id} style={{ verticalAlign: "middle" }}>
                    <td>{i + 1}</td>
                    <td>
                      {winner?.betting_id?.name ||
                        winner?.betting_id?.userId?.name ||
                        winner?.userId?.name}
                    </td>
                    <td>
                      {winner?.betting_id?.phone ||
                        winner?.betting_id?.userId?.phone ||
                        winner?.userId?.phone}
                    </td>
                    <td>{winner?.betting_id?.betNumber}</td>

                    <td>{winner?.betting_id?.amount}</td>
                    <td>{winner?.result_id?.odds}</td>
                    <td className="text-end">
                      {(
                        winner?.betting_id?.amount * winner?.result_id?.odds
                      )?.toLocaleString("en-us")}
                    </td>
                    <td>
                      {winner?.status === "approved" && (
                        <span className="badge bg-success">Approved</span>
                      )}

                      {winner?.status === "pending" && (
                        <span className="badge bg-warning">Pending</span>
                      )}

                      {winner?.status === "rejected" && (
                        <span className="badge bg-danger">Rejected</span>
                      )}
                    </td>
                    <td>
                      {moment(winner?.createdAt)
                        .utc()
                        .format("DD-MM-YYYY, hh:mm:ss A")}
                    </td>
                    <td>{formatDate(winner?.updatedAt)}</td>
                  </tr>
                ))}
            </TableBody>
            <TableFooter>
              <tr style={{ verticalAlign: "middle" }}>
                <td colSpan="6">
                  <strong>Total</strong>
                </td>
                <td className="text-end">
                  <strong>
                    {calculateTotal(
                      winners?.map((el) => {
                        const data = {};
                        data.amount =
                          el?.betting_id?.amount * el?.result_id?.odds;
                        return data;
                      }),
                      "amount"
                    )}
                  </strong>
                </td>
                <td className="text-end" colSpan={3}></td>
              </tr>
            </TableFooter>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
    </Template>
  );
};

export default Winners;
